/**
 * SASS
 */
import '../scss/main.scss';

/**
 * JavaScript
 */

// General
import anchorListener from './general/AnchorListener';
import copyContent from './general/CopyContent';
import {bodyListener} from './general/body';
import expanderListener from './general/ExpanderListener';
import wcag from './general/wcag';

// Utilities
import printContent from './utilities/printContent';
// import linkToHiddenFormField from './utilities/linkToHiddenFormField';

// Builder
import linkBlock from './builder/linkBlock';
import commitesDeparments from './builder/commitesDeparments';
import postTypeCarousel from './builder/postTypeCarousel';

// Components
import languageSwitcher from './components/languageSwitcher';
import tooltips from './components/tooltips';
import gallery from './components/gallery/gallery';
import verticalTimeline from './components/vertical-timeline';
import horizontalTimeline from './components/horizontal-timeline';
import searchBar from './components/searchBar';
import publicationsSlider from './components/publications-slider';
import modalListener from './components/modalListener';
import contentAside from './components/section-content-aside';
import videoControllerListener from './components/video';
import navigation from './components/navigation';
import mobileNavigation from './components/mobileNavigation';
import relatedPostsSlider from './components/related-posts-slider';
import eventRegistrationForm from './components/eventRegistrationForm';
import patronageContent from './components/patronage-content';
import popularTags from './components/popularTags';
import membersSidebar from './components/membersSidebar';
import contentWysiwyg from './components/contentWysiwyg';
import contactList from './components/contactList';
import fileInputListener from './components/fileInputListener';
import collapseListener from './components/collapseListener';
import googleMaps from './components/googleMaps';
import topbarNavExpander from './components/topbarNavExpander';
import realEstateListingFilters from './components/listingFilters';
import offerImagesSlider from './components/offerImagesSlider';

import realEstatePageHandler from './pages/realEstate';
import realEstateListingHandler from './pages/realEstateListing';

(() => {
    // General
    bodyListener();
    anchorListener();
    expanderListener();
    copyContent();
    wcag();
    googleMaps();

    //Utilities
    printContent();
    // linkToHiddenFormField();

    // Builder
    linkBlock();
    commitesDeparments();
    postTypeCarousel();

    // Components
    languageSwitcher();
    tooltips();
    gallery();
    verticalTimeline();
    horizontalTimeline();
    searchBar();
    publicationsSlider();
    modalListener();
    contentAside();
    videoControllerListener();
    navigation();
    mobileNavigation();
    relatedPostsSlider();
    eventRegistrationForm();
    patronageContent();
    popularTags();
    membersSidebar();
    contentWysiwyg();
    contactList();
    fileInputListener();
    collapseListener();
    topbarNavExpander();
    offerImagesSlider();
    
    // Pages
    realEstateListingFilters();
    realEstatePageHandler();
    realEstateListingHandler();
})();
